"use strict";
import { Interface } from "@ethersproject/abi";
import invariant from "tiny-invariant";
import IApproveAndCall from "@uniswap/swap-router-contracts/artifacts/contracts/interfaces/IApproveAndCall.sol/IApproveAndCall.json";
import {
  NonfungiblePositionManager,
  toHex
} from "@uniswap/v3-sdk";
import JSBI from "jsbi";
export var ApprovalTypes = /* @__PURE__ */ ((ApprovalTypes2) => {
  ApprovalTypes2[ApprovalTypes2["NOT_REQUIRED"] = 0] = "NOT_REQUIRED";
  ApprovalTypes2[ApprovalTypes2["MAX"] = 1] = "MAX";
  ApprovalTypes2[ApprovalTypes2["MAX_MINUS_ONE"] = 2] = "MAX_MINUS_ONE";
  ApprovalTypes2[ApprovalTypes2["ZERO_THEN_MAX"] = 3] = "ZERO_THEN_MAX";
  ApprovalTypes2[ApprovalTypes2["ZERO_THEN_MAX_MINUS_ONE"] = 4] = "ZERO_THEN_MAX_MINUS_ONE";
  return ApprovalTypes2;
})(ApprovalTypes || {});
export function isMint(options) {
  return Object.keys(options).some((k) => k === "recipient");
}
export class ApproveAndCall {
  static {
    this.INTERFACE = new Interface(IApproveAndCall.abi);
  }
  /**
   * Cannot be constructed.
   */
  constructor() {
  }
  static encodeApproveMax(token) {
    return ApproveAndCall.INTERFACE.encodeFunctionData("approveMax", [token.address]);
  }
  static encodeApproveMaxMinusOne(token) {
    return ApproveAndCall.INTERFACE.encodeFunctionData("approveMaxMinusOne", [token.address]);
  }
  static encodeApproveZeroThenMax(token) {
    return ApproveAndCall.INTERFACE.encodeFunctionData("approveZeroThenMax", [token.address]);
  }
  static encodeApproveZeroThenMaxMinusOne(token) {
    return ApproveAndCall.INTERFACE.encodeFunctionData("approveZeroThenMaxMinusOne", [token.address]);
  }
  static encodeCallPositionManager(calldatas) {
    invariant(calldatas.length > 0, "NULL_CALLDATA");
    if (calldatas.length === 1) {
      return ApproveAndCall.INTERFACE.encodeFunctionData("callPositionManager", calldatas);
    } else {
      const encodedMulticall = NonfungiblePositionManager.INTERFACE.encodeFunctionData("multicall", [calldatas]);
      return ApproveAndCall.INTERFACE.encodeFunctionData("callPositionManager", [encodedMulticall]);
    }
  }
  /**
   * Encode adding liquidity to a position in the nft manager contract
   * @param position Forcasted position with expected amount out from swap
   * @param minimalPosition Forcasted position with custom minimal token amounts
   * @param addLiquidityOptions Options for adding liquidity
   * @param slippageTolerance Defines maximum slippage
   */
  static encodeAddLiquidity(position, minimalPosition, addLiquidityOptions, slippageTolerance) {
    let { amount0: amount0Min, amount1: amount1Min } = position.mintAmountsWithSlippage(slippageTolerance);
    if (JSBI.lessThan(minimalPosition.amount0.quotient, amount0Min)) {
      amount0Min = minimalPosition.amount0.quotient;
    }
    if (JSBI.lessThan(minimalPosition.amount1.quotient, amount1Min)) {
      amount1Min = minimalPosition.amount1.quotient;
    }
    if (isMint(addLiquidityOptions)) {
      return ApproveAndCall.INTERFACE.encodeFunctionData("mint", [
        {
          token0: position.pool.token0.address,
          token1: position.pool.token1.address,
          fee: position.pool.fee,
          tickLower: position.tickLower,
          tickUpper: position.tickUpper,
          amount0Min: toHex(amount0Min),
          amount1Min: toHex(amount1Min),
          recipient: addLiquidityOptions.recipient
        }
      ]);
    } else {
      return ApproveAndCall.INTERFACE.encodeFunctionData("increaseLiquidity", [
        {
          token0: position.pool.token0.address,
          token1: position.pool.token1.address,
          amount0Min: toHex(amount0Min),
          amount1Min: toHex(amount1Min),
          tokenId: toHex(addLiquidityOptions.tokenId)
        }
      ]);
    }
  }
  static encodeApprove(token, approvalType) {
    switch (approvalType) {
      case 1 /* MAX */:
        return ApproveAndCall.encodeApproveMax(token.wrapped);
      case 2 /* MAX_MINUS_ONE */:
        return ApproveAndCall.encodeApproveMaxMinusOne(token.wrapped);
      case 3 /* ZERO_THEN_MAX */:
        return ApproveAndCall.encodeApproveZeroThenMax(token.wrapped);
      case 4 /* ZERO_THEN_MAX_MINUS_ONE */:
        return ApproveAndCall.encodeApproveZeroThenMaxMinusOne(token.wrapped);
      default:
        throw new Error("Error: invalid ApprovalType");
    }
  }
}
